module.exports = __webpack_public_path__ + "static/background-dfe798787352b626f1ea7b9c3f6ae85c.jpg";